import AuthService from '../services/auth.service';
const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? {
        status: { loggedIn: true },
        user,
        tokenInfo: {},
        remaining: {}
    }
    : {
        status: { loggedIn: false },
        user: null,
        tokenInfo: {},
        remaining: {}
    };

function unixToDate(unix) {
    if (!unix) return "-";
    return new Date(unix * 1000).toLocaleString("ko-KR");
}

function secondsToString(sec) {
    if (sec <= 0) return "Expired";

    const day = Math.floor(sec / 86400);
    sec %= 86400;

    const hour = Math.floor(sec / 3600);
    sec %= 3600;

    const min = Math.floor(sec / 60);
    sec %= 60;

    const result = [];

    if (day) result.push(`${day}일`);
    if (hour) result.push(`${hour}시간`);
    if (min) result.push(`${min}분`);
    result.push(`${sec}초`);

    return result.join(" ");
}

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        }
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;

            state.tokenInfo = {

                accessIssued: unixToDate(user.accessIat),
                accessExpires: unixToDate(user.accessExp),
                accessDuration: secondsToString(user.accessExp - user.accessIat),

                refreshIssued: unixToDate(user.refreshIat),
                refreshExpires: unixToDate(user.refreshExp),
                refreshDuration: secondsToString(user.refreshExp - user.refreshIat)

            };     
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;

            state.tokenInfo = {};
            state.remaining = {};
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
        updateTokenInfo(state) {
            if (!state.user) return;

            state.tokenInfo = {
                accessIssued: unixToDate(state.user.accessIat),
                accessExpires: unixToDate(state.user.accessExp),
                accessDuration: secondsToString(state.user.accessExp - state.user.accessIat),

                refreshIssued: unixToDate(state.user.refreshIat),
                refreshExpires: unixToDate(state.user.refreshExp),
                refreshDuration: secondsToString(state.user.refreshExp - state.user.refreshIat)
            };
        },
        updateRemaining(state) {
            if (!state.user) return;

            const now = Math.floor(Date.now() / 1000);

            const total = state.user.refreshExp - state.user.refreshIat;
            const remain = Math.max(0, state.user.refreshExp - now);

            const percent = remain / total;

            let color = "#28a745";

            if (percent < 0.05)
                color = "#dc3545";
            else if (percent < 0.20)
                color = "#fd7e14";

            state.remaining = {
                accessRemaining: secondsToString(state.user.accessExp - now),
                refreshRemaining: secondsToString(remain),

                refreshPercent: percent,
                refreshColor: color
            };
        },
        setUser(state, user) {
            state.user = user;
        }
    }
};